// Course Package Import — Markdown -> HTML (browser + Node).
// Uses markdown-it (CJS, no React) so it runs in the app and in Node tests.
// The resulting HTML is always sanitised with lib/sanitize.sanitizeHtml
// before it is saved (done by the block creator). PRD §5.3 (Reading).

import MarkdownIt from 'markdown-it';

const md = new MarkdownIt({ html: true, linkify: true, breaks: false });

export function markdownToHtml(src) {
  if (src == null) return '';
  try {
    return md.render(String(src));
  } catch (e) {
    const escaped = String(src)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return `<p>${escaped}</p>`;
  }
}

export default markdownToHtml;
